import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Percentage from "../axes/Percentage";
import MoistureAxes from "../axes/Moisture";

let SoilStickMoisturePercent = {
    type: "line",
    label: "Soil Moisture (%)",
    fill: true,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:MoistureAxes,
    xAxis:Time
};

export default SoilStickMoisturePercent;



// WEBPACK FOOTER //
// ./src/components/chart/channels/SoilStickMoisturePercent.js